import {reportYear,metaData} from '../../util/util'
import httpManager from '../../util/common'
import country_code from '../../../i18n/zh.json'
import XEUtils from "xe-utils";
const reportRaw = reportYear.report_years


export default {

  data () {
    return {
      placeholder: this.select_tag ? '无人驾驶/' + this.select_tag : '标签',
      // 表格标签名称
      form_tagname: '',
      // 标签列表
      tag_types: [
        {
          label: '无人驾驶',
          value: '无人驾驶',
          children: [
            {label: '巨头布局', value: '巨头布局'},
            {label: '智慧物流', value: '智慧物流'},
            {label: '智慧交通', value: '智慧交通'},
            {label: '车辆控制', value: '车辆控制'},
            {label: '高精度地图', value: '高精度地图'},
            {label: '激光雷达', value: '激光雷达'},
            {label: '芯片', value: '芯片'},
            {label: '卡车运输', value: '卡车运输'},
            {label: '辅助驾驶', value: '辅助驾驶'},
            {label: '自动驾驶', value: '自动驾驶'},
            {label: '传感摄像', value: '传感摄像'},
            {label: '毫米波雷达', value: '毫米波雷达'},
            {label: '车联网', value: '车联网'},
            {label: '特定场景', value: '特定场景'},
            {label: '算法', value: '算法'},
            {label: '激光雷达', value: '激光雷达'},
            {label: '毫米波雷达', value: '毫米波雷达'},
            {label: '辅助驾驶', value: '辅助驾驶'}
          ]
        }
      ],
      select_tag: '',
      select_name: '',
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'center',
        pagerCount: 3,
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true
      },
      loading: false,
      data: []
    }
  },
  methods: {
    // 标签更改
    tagOnChange (value) {
      this.placeholder = '标签'
      this.form_tagname = ''
      this.select_tag = value[value.length - 1]
      for(let i=0; i < value.length; i++){
        this.form_tagname += value[i] +'/'
      }
      this.form_tagname = this.form_tagname.substring(0, this.form_tagname.length-1)
    },
    // 翻页
    pageChange ({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getCompanyData()
    },
    // 点击公司名称跳转
    cellClickEvent ({row, column}) {
      // 点击简称、全称  跳转至首页该公司
      if(column.property == "short_name" || column.property == "full_name"){
        const {
          href
        } = this.$router.resolve({path:  '/entity/'+row.oa_id+'/home'})
        window.open(href, '_blank')
      }
      // 点击网站  跳转至该公司官网
      if(column.property == "website"){
        window.open("http://" + row.website)
      }
    },
    // 获取数据
    getCompanyData () {
      let self = this
      self.loading = true
      let params = new Map()
      params.set("pagenum",self.page.currentPage)
      params.set("pagesize",self.page.pageSize)

      // if(self.select_tag)
      params.set("scope", self.select_tag)
      // if(self.select_name)
      params.set("name", self.select_name)
      httpManager("driverless_company_data", params, null, null, null)
        .then(response => {
          self.data = response.data.data
          let page = response.data.page
          self.page.total = page.total
          self.loading = false
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },
  },
  created () {
    this.select_tag = this.$route.query.select_tag
    this.select_name = this.$route.query.select_name
  },
  mounted () {
    this.getCompanyData()
    this.placeholder = this.select_tag ? '无人驾驶/' + this.select_tag : '标签'
  },
  watch: {
    select_tag: function () {
      this.page.currentPage = 1
      this.getCompanyData()
    },
    select_name: function () {
      this.page.currentPage = 1
      this.getCompanyData()
    }
  },
  computed: {
    tableColumn() {
      return [
        {type: 'seq', width: 50},
        {title: this.$t('common.company_short_name'), field: "short_name", className: 'driverless-selected-company'},
        {title: this.$t('common.company_full_name'), field: "full_name", width:"200", className: 'driverless-selected-company'},
        {title: this.$t('supplychain.national_economy_industry'), field: "major_industry",width: "300"},
        {title: this.$t('common.tag'), field: "taglib", width: "160", formatter:({cellValue})=>{
            return '无人驾驶/' + cellValue
          }},
        {title: this.$t('supplychain.establishment_date'), field: "esdate",formatter:({ cellValue })=>{
            let date = new Date(cellValue)
            let year = date.getFullYear()
            let mounth = date.getMonth()+1
            let day = date.getDay()
            return year + "-" +mounth +"-" +day
          },
        },
        {title: this.$t('supplychain.official_website'), field: "website", width: "200", className: 'driverless-selected-company'},
        {title: this.$t('supplychain.business_licated_region'), field: "dom_country",formatter:({cellValue})=>{
            return country_code["country"][cellValue]
        }},
        {title: this.$t('supplychain.registration_located_region'), field: "incorporated_country",formatter:({cellValue})=>{
            return country_code["country"][cellValue]
          }},

      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/supplychain/js/driverless_company.js